<template>
    <v-card>

        <v-card-text class="d-flex flex-column">

            <v-form style="gap: 16px;" class="d-flex flex-row flex-sm-column flex-lg-row flex-x l-row">

                <div style="display: flex; flex-direction: column; width:100%;">

                    <v-container style="padding: 0;">
                        <v-col md="12">
                            <generic-data-table :items="waybills" :loading="loading" :headers="waybillHeaders"
                                :hideAddButton="true" entity_name="wayBill" :localizable_fields="[]"
                                :showCardView="false"
                                @rowClick="row => simulateRow(row)" no_actions>
                            </generic-data-table>
                        </v-col>

                    </v-container>

                </div>

                <div class="custom-divider"></div>

                <div style="display: flex; flex-direction: column; width:100%; gap: 16px;">

                    <div no-gutters style="padding: 0; height: fit-content;">

                        <v-row no-gutters>
                            <v-expansion-panels color="primary" accordion>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        <v-row style="gap: 12px;" no-gutters>
                                            <div class="d-flex align-items-center"><v-icon color="primary">{{
                                                "mdi-qrcode" }}</v-icon></div>
                                            <div style="gap: 4px;">
                                                <div class="upper-text body-2">Pick points on map</div>
                                                <div class="lower-text-gray body-1">Use map to pick locations by
                                                    dropping pins</div>
                                            </div>
                                        </v-row>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div>
                                            <google-map :realtime_tracking="true" :simulated="simulatedDriver"
                                                :simulatedLinePoints="linePoints" />
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>

                    </div>

                </div>

            </v-form>

        </v-card-text>

    </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import GoogleMap from '../GoogleMap'
import MobilePhones from '../../views/MobilePhones'
import MobilePhonesStandalone from '../MobilePhonesStandalone'
import Multiselect from 'vue-multiselect'
import MediaGallery from '../common/MediaGallery'
import GenericDataTable from '@/components/GenericDataTable'
import Utils from '../../mixins/utils'
import ShareByEmail from '../../mixins/shareByEmail'
export default {
    data() {
        return {
            errorMessage: '',
            enableValidation: false,
            showDeleteConfirm: false,
            rules: {
                field: [
                    v => !!v || 'This Field is Required',
                ]
            },
            lang_code: 'en',
            showField: true, //hack to reload the localizable field,
            showAddStandalonePhone: false,
            standalone_phones: [],
            fromDateMenu: false,
            minDate: "1900-01-01",
            search_val: null,

            selectedMulti: [],
            modal: {
                mediaGalleryShown: {
                    type1: false,
                    type2: false,
                    type3: false,
                    type4: false,
                    type5: false,
                    type6: false,
                    type7: false,
                    type8: false
                },
                qrCodeGalleryShown: false
            },
            showQr: true,
            postLoading: false,
            email_shown: true,
            password_shown: true,
        }
    },
    mixins: [Utils, ShareByEmail],
    components: { GoogleMap, MobilePhones, MobilePhonesStandalone, Multiselect, MediaGallery, GenericDataTable },
    computed: {
        show: {
            get() {
                return this.isShown
            },
            set(value) {
                this.standalone_phones = []
                this.$emit('changed', value)
            }
        },
        isExistingEntity() {
            return this.current_entity[this.entityName] != undefined && this.current_entity[this.entityName].id
        },
        ...mapState('entities', ['loading', 'current_entity', 'entities', 'search', 'selected_search_entity']),
        ...mapState('users', ['user']),
        ...mapGetters('entities', ['allowDelete']),
        ActualCurrentEntity() {
            return this.current_entity[this.entityName]
        },
        Languages() {
            return this.entities['language']
        },
        CurrentLanguage() {
            for (var i = 0; i < this.Languages.length; ++i) {
                var lang = this.Languages[i]
                if (lang.code === this.lang_code) return lang
            }
            return null
        },
        CurrentLocalization() {
            if (this.ActualCurrentEntity.localizations === undefined || !Array.isArray(this.ActualCurrentEntity.localizations)) {
                this.ActualCurrentEntity.localizations = []
            }

            var loc = null;
            var loc_found = false
            for (var i = 0; i < this.ActualCurrentEntity.localizations.length; ++i) {
                var l = this.ActualCurrentEntity.localizations[i]
                if (l.languageId === this.CurrentLanguage.id) loc = l
            }
            if (loc === null) {
                loc = { languageId: this.CurrentLanguage.id }
                for (var i = 0; i < this.localizable_fields.length; ++i) {
                    loc[this.localizable_fields[i].value] = ""
                }
                this.current_entity[this.entityName].localizations.push(loc)
            }
            return loc
        },
        CurrentSearchEntity(name) {
            return this.current_entity[name] !== undefined ? this.entities[name].find(x => x.id === this.current_entity[name].userId) : this.selected_search_entity[name]
        },
        StationsSelects() {
            return this.entity_fields.filter(h => h.type === 'multiselect' && h.include_in_station);
        }
    },
    props: ['fullscreen', 'isShown', 'entityName', 'coordinate', 'entity_fields', 'localizable_fields', 'user_id', 'driver_id'], //the data we're editing might belong to a user or driver
    methods: {
        ...mapActions('entities', ['getEntities', 'saveEntity', 'deleteEntity', 'searchEntities']),

        save() {
            if (this.$refs.form.validate()) {
                this.postLoading = true
                this.errorMessage = ''
                var post_object = { ...this.ActualCurrentEntity }

                post_object.entity_name = this.entityName
                if (this.standalone_phones.length > 0) post_object.phones = this.standalone_phones
                if (this.selected_search_entity['user'] !== undefined) {
                    post_object.userId = this.selected_search_entity['user'].id
                }
                if (post_object.packages !== undefined) {
                    post_object.packageIds = post_object.packages.map(p => p.id)
                    post_object.packages = null;
                    post_object.packageWayBills = null
                }
                if (post_object.drivers !== undefined) {
                    post_object.driverIds = post_object.drivers.map(d => d.id)
                    post_object.drivers = null
                    post_object.driverWayBills = null
                }
                if (post_object.trucks !== undefined) {
                    post_object.truckIds = post_object.trucks.map(t => t.id)
                    post_object.trucks = null
                    post_object.truckWayBills = null
                }
                if (post_object.user !== undefined) {
                    post_object.userId = post_object.user.id
                    post_object.user = null
                }
                if (post_object.qrCodeMedia !== undefined) {
                    if (post_object.qrCodeMedia.id !== undefined) {
                        post_object.qrCodeMediaId = post_object.qrCodeMedia.id
                        post_object.qrCodeMedia = null
                    }
                }
                if (this.user_id !== undefined) post_object.userId = this.user_id
                if (this.selected_search_entity['driver'] !== undefined) post_object.driverId = this.selected_search_entity['driver'].id
                if (this.driver_id !== undefined) post_object.driverId = this.driverId

                post_object.isActive = true;
                console.log(post_object)
                this.saveEntity(post_object).then(message => {
                    console.log(`post success`);
                    this.$emit('entityPosted');
                    this.postLoading = false;
                    if (post_object.sendToFreight !== undefined && post_object.sendToFreight === true) {
                        console.log('should send to freight');
                        this.sendToFreight(false, post_object);
                    }
                    this.getEntities(this.entityName);//this.selectedFFId)
                    this.driverDetailsShown = false;
                    this.closeClicked();
                }).catch(message => {
                    if (message == null) {
                        this.errorMessage = "There are validation errors. Kindly check your inputs and try again.";
                    } else {
                        this.errorMessage = message;
                    }
                    this.postLoading = false;
                })
            }
            this.enableValidation = true;
        },
        deleteEntity() {
            this.showDeleteConfirm = false
            this.deleteEntity(this.current_entity[this.entityName], this.entityName).then(message => {
                this.show = false;
            }).catch(message => {
                this.errorMessage = message;
            })
        },
        setLanguage(lang) {
            this.showField = false;
            this.lang_code = lang.code;
            setTimeout(h => { this.showField = true }, 100);
        },
        clearSearch(entity) {
            this.search[entity] = [];
        },
        getSearchItems() {
            var items = this.search['user'];
            return items;
        },
        fetchEntriesDebounced() {
            clearTimeout(this._searchTimerId);
            this._searchTimerId = setTimeout(() => {
                this.fetchEntries();
            }, 500) /* 500ms throttle */
        },
        onSelect(option, id) {
            console.log(option, id);
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            }
            this.options.push(tag);
            this.value.push(tag);
        },
        selectMedia(item) {
            if (item.typeId === 5) {
                this.ActualCurrentEntity.qrCodeMediaId = item.id;
                this.ActualCurrentEntity.qrCodeMedia = item;
                this.ActualCurrentEntity.qrCode = item.name;
            }
            else {
                if (!(this.current_entity[this.entityName] != undefined && this.current_entity[this.entityName].id)) {
                    item.id = null;
                }
                if (this.ActualCurrentEntity.medias == null) this.ActualCurrentEntity.medias = []
                //find first an item with the same type and replace it
                var mediaIndex = this.ActualCurrentEntity.medias.findIndex(m => m.typeId == item.typeId)
                if (mediaIndex === undefined || mediaIndex === -1) {
                    this.ActualCurrentEntity.medias.push(item);
                }
                else {
                    this.ActualCurrentEntity.medias[mediaIndex] = item;
                }
            }
        },
        removeMedia(item) {
            var index = this.ActualCurrentEntity.medias.indexOf(m => m.id === item.id);
            if (index !== undefined && index !== null) {
                this.ActualCurrentEntity.medias.splice(index, 1);
            }
        },
        getMediaUrl(type) {
            if (this.ActualCurrentEntity.medias !== null && Array.isArray(this.ActualCurrentEntity.medias)) {
                var media = this.ActualCurrentEntity.medias.find(obj => obj.typeId === type)
                return (media !== undefined && media !== null) ? media.url : ""
            }
            return null;
        },
        shouldShowMedia(type) {
            if (this.ActualCurrentEntity.medias !== null && Array.isArray(this.ActualCurrentEntity.medias)) {
                var media = this.ActualCurrentEntity.medias.filter(obj => obj.typeId === type)
                return (media !== undefined && media !== null) ? true : false;
            }
        }
        ,
        openMediaGallery(media_type) {
            this.modal.mediaGalleryShown[`type${media_type}`] = true;
        },
        setGeoFence(fence) {
            this.ActualCurrentEntity.geoRegions = fence;
        },
        setStationsList(stationsList) {
            this.ActualCurrentEntity.deliveryAddresses = stationsList;
        },
        generateChipStyle(color) {
            var styleDef = `.${color} .multiselect__tag{background:${color} !important;}`
            let style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = styleDef;
            document.head.appendChild(style);
            return color;
        },
        generateQrCode(id, selectorValue, selectorId) {
            axios({
                method: "GET",
                url: `${process.env.VUE_APP_baseURL}media/generateQr?id=${id}`
            }).then(response => {
                var qrMedia = response.data.data.value;
                this.ActualCurrentEntity[selectorValue] = qrMedia;
                this.ActualCurrentEntity[selectorId] = qrMedia.id;
                this.ActualCurrentEntity.qrCode = qrMedia.name;
                this.forceReloadQr();
            }).catch(error => {
                console.log(`ERRORRRRRRRRR ${error}`);
            })
        },
        forceReloadQr() {
            this.showQr = false
            setTimeout(() => { this.showQr = true }, 150);
        },
        closeClicked() {
            this.$emit('closeClicked');
        },
        localizedTextfieldChanged(fieldName) {
            console.log(`${fieldName} changed`);
            if (fieldName != null && fieldName.includes('firstName') && this.CurrentLocalization.languageId === 1) {
                var value = this.CurrentLocalization[fieldName];
                var filteredValue = value.replace(" ", "_");
                this.ActualCurrentEntity.email = `${filteredValue}@tracking.com`;
                this.email_shown = false;
                setTimeout(() => {
                    this.email_shown = true
                }, 50);
            }
        },
        generateUPassword() {
            this.ActualCurrentEntity.password = Array(10).fill("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz").map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('');
            this.password_shown = false;
            setTimeout(() => { this.password_shown = true }, 50);
        },
        sendToFreight(genNewPassword = true, post_object = null) {
            console.log('sending to')
            if (genNewPassword || this.ActualCurrentEntity.password === undefined || this.ActualCurrentEntity.password.length === 0) this.generateUPassword()
            var emailObject = {
                entityId: post_object.id,
                email: post_object.email,
                password: post_object.password
            }
            var url = `${this.entityName}/shareByEmail`;
            this.sendEmailEntity(emailObject, url);
        }
    },
    model: {
        prop: 'isShown',
        event: 'changed'
    },
    watch: {
        show(newValue) {
            if (newValue) {
                this.data = Object.assign({}, this.user)
                if (this.$refs.form != undefined)
                    this.$refs.form.resetValidation();

                this.errorMessage = '';
                this.enableValidation = false;
            }
            else {
                this.ActualCurrentEntity = {}
                this.$emit('editItemHidden');
            }
        },
        data: {
            deep: true,
            handler() {
                if (this.enableValidation)
                    this.$refs.form.validate();
            }
        },
        search_val(val) {
            if (this.search['user'] !== undefined && this.search['user'].length > 0) return
            if (val !== undefined && val !== null) {
                //search for the user and populate the users
                var searchPayLoad = {
                    entity_name: 'user',
                    query: val,
                    fromPage: -1,
                    toPage: -1,
                    count: -1
                }
                this.searchEntities(searchPayLoad)
            }
        }
    },
    mounted() {
        this.errorMessage = "";
        if (this.localizable_fields !== undefined && this.localizable_fields.length > 0) {
            //should check if the current entity has a localizations array, else add one
            if (this.ActualCurrentEntity.localizations === undefined || !Array.isArray(this.ActualCurrentEntity.localizations)) {
                this.ActualCurrentEntity.localizations = [];

                //load the array with empty localiable fields for each language
                for (var i = 0; i < this.Languages.length; ++i) {
                    var loc = {};
                    loc.languageId = this.Languages[i].id;
                    for (var j = 0; j < this.localizable_fields.length; ++j) {
                        var field = this.localizable_fields[j];
                        loc[field.value] = "";
                    }
                    this.ActualCurrentEntity.localizations.push(loc);
                }
            }
        }
        if (this.ActualCurrentEntity.id === undefined || this.ActualCurrentEntity.id === 0) {
            this.ActualCurrentEntity.password = "123456";
        }
        this.localizedTextfieldChanged("firstName");
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.img-div {
    background-size: contain;
    margin-bottom: 15px;
    height: 100px;
}

.logo-container {
    text-align: center;
}

@media print {
    header {
        display: none;
    }
}
</style>